import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, IconButton, Typography,
} from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import EditNoteIcon from '@mui/icons-material/EditNote';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import { is } from 'date-fns/locale';
export const Modal = ({
    title = '',
    ButtonDelete,
    isOpen = '',
    openHash = '',
    statement = '',
    body = null,
    overflow = false,
    small = false,
    big = false,
    onClosed,
    primaryButton = '',
    closeOnSubmit = true,
    deleteConfirmation = false,
    callOnClosed = true,
    className = '',
    Icon = '',
    isShowwarning = false,
    setNoteshowwarning,
    setCommentshowwarning,
}: {
    title?: string;
    ButtonDelete?: () => void;
    isOpen?: string;
    openHash?: string;
    statement?: string;
    body?: React.ReactNode;
    overflow?: boolean;
    small?: boolean;
    big?: boolean;
    onClosed?: () => void;
    primaryButton?: string;
    closeOnSubmit?: boolean;
    deleteConfirmation?: boolean;
    callOnClosed?: boolean;
    className?: string;
    Icon?: string;
    isShowwarning?: boolean;
    setNoteshowwarning?: (value: boolean) => void;
    setCommentshowwarning?: (value: boolean) => void;
}) => {
    const { t } = useTranslation();

    const [open, setOpen] = useState(() => isOpen);
    const [showWarningPopup, setShowWarningPopup] = useState(false); // State to control warning popup visibility

    const handleClose = () => {
        if (isShowwarning) {
            setShowWarningPopup(true); // Show warning popup if unsaved changes are detected
            if (setNoteshowwarning) {
                setNoteshowwarning(false); // Call the function with a boolean value
            }
            if (setCommentshowwarning) {
                setCommentshowwarning(false); // Call the function with a boolean value
            }
        } else {
            setOpen('');
            onClosed && onClosed();
        }
    }

    const handleCloseOnConfirmation = () => {
        setOpen('');
        callOnClosed && onClosed && onClosed();
    }

    const handleConfirmClose = () => {
        setShowWarningPopup(false); // Hide the warning popup
        setOpen('');
        onClosed && onClosed(); // Proceed with closing the modal
    };

    const handleCancelClose = () => {
        setShowWarningPopup(false); // Hide the warning popup
    };

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen, openHash])

    return (
    <>
        <Dialog className={className} open={open !== ''} onClose={handleClose} fullWidth={body && !small ? true : false} maxWidth={body && !small ? (big ? 'xl' : 'lg') : 'sm'}
            disableAutoFocus={true}>
            {title && (
                <>
                    <DialogTitle id="responsive-dialog-title"
                        sx={{
                            backgroundColor: "#E8F3F4",
                            textAlign: "center",
                            fontSize: "18px"
                        }}
                    >{title}
                   {Icon && Icon === 'comment' ? (
                        <InsertCommentIcon style={{ color: 'white', marginLeft: '8px',  marginBottom: '-8px'  }} />
                    ) : Icon === 'notes' ? (
                        <EditNoteIcon style={{ color: 'white', marginLeft: '8px',  marginBottom: '-8px'  }} />
                    ) : null}
                                        
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: '#FFFFFF',
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </>
            )}
            <DialogContent>
                {(!body && deleteConfirmation) ? (
                    <DialogContentText sx={{
                        fontSize: "16px",
                        color: '#000000',
                        textAlign: "center",
                        fontFamily: 'Roboto',
                        mt: 5,
                        mb: 5,
                    }}>
                        <div>
                            <ErrorOutlineIcon style={{ fontSize: '50px', color: '#FD5900', paddingBottom: '33px' }} />
                        </div>
                        {t('You are about to delete the items you selected')}.<br />
                        {t('Are you sure')}?
                    </DialogContentText>

                ) : (
                    <>
                        {body}
                    </>
                )}

            </DialogContent>

            {ButtonDelete && (
                <DialogActions
                    sx={{
                        backgroundColor: "#E8F3F4"
                    }}
                >
                    <Button variant='outlined' onClick={handleClose}>
                        <Typography style={{ textTransform: 'none', color: "grey" }}>{t('Cancel')}</Typography>
                    </Button>

                    <Button variant='contained'
                        onClick={() => {
                            ButtonDelete();
                            if (closeOnSubmit) handleCloseOnConfirmation();
                        }}
                    >

                        <span style={{ color: '#FFF' }}>{t(primaryButton || 'Confirm')}</span>
                    </Button>

                </DialogActions>
            )}
        </Dialog>

         {/* Warning Popup */}
         <Dialog open={showWarningPopup} onClose={handleCancelClose}>
         <DialogTitle
                sx={{
                    background: '#006a68', // Set background color
                    color: '#fff', // Set text color
                    fontSize: '18px !important', // Set font size
                    fontWeight: 'bold', // Optional: Make the text bold
                    textAlign: 'center', // Optional: Center the text
                }}
            >
                {t('Unsaved Changes')}
            </DialogTitle>
                <DialogContent>
                    <p>{t('You have unsaved changes. Are you sure you want to close?')}</p>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="secondary" onClick={handleCancelClose}>
                        {t('Cancel')}
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleConfirmClose}>
                        {t('Confirm')}
                    </Button>
                </DialogActions>
            </Dialog>

</>
    )
}

